module.exports = __webpack_public_path__ + "img/trainings-1.7bb5db81.png";